import React from "react";
import styled from "styled-components";
import { Field, FieldProps, FieldRenderProps } from "react-final-form";
import {Filter} from "bad-words";

const filter = new Filter();


interface FormInputProps extends FieldProps<string, FieldRenderProps<string>> {
  label?: string;
  placeholder?: string;
  tooltip?: React.ReactNode;
  info?: React.ReactNode;
  error?: React.ReactNode;
}

// validation logic
const validateName = (value?: string) => {
  if (!value) return "This field is required";
  if (value.length < 2) return "Must be at least 2 characters";

  if (!/^[A-Za-z\u0531-\u0556\u0561-\u0587\s]+$/.test(value.trim())) {
    return "Only letters are allowed";
  }

  if (filter.isProfane(value)) {
    return "Please avoid using inappropriate words";
  }

  return undefined;
};

export const Input: React.FC<FormInputProps> = (props) => {
  return (
    <Field
      type="text"
      validate={
        props.name === "firstname" || props.name === "lastname"
          ? validateName
          : undefined
      }
      render={(inputProps) => (
        <Container>
          <AuthInput
            placeholder={props.placeholder}
            error={!!inputProps.meta.error && inputProps.meta.touched}
            {...inputProps.input}
          />
          {inputProps.meta.touched && inputProps.meta.error && (
            <Error>{inputProps.meta.error}</Error>
          )}
          {!!props.info && <Info>{props.info}</Info>}
        </Container>
      )}
      {...props}
    />
  );
};


const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex: 1;
`;

const AuthInput = styled.input<{ error?: boolean }>`
  background-color: #1a1a1a !important;
  border: 1px solid ${(props) => (props.error ? "#FF5151" : "#333")};
  border-radius: 12px;
  padding: 14px 16px;
  font-size: 16px;
  font-weight: 300;
  color: #fff;
  width: 100%;
  height: 50px;

  &:focus {
    outline: none;
    border-color: #fff;
  }

  &::placeholder {
    color: #888;
  }
`;

const Info = styled.span`
  font-size: 12px;
  color: #888;
`;

const Error = styled.span`
  font-size: 14px;
  line-height: 19px;
  color: #ff5151;
`;
